import styles from '../../../assets/styles/home.module.scss';
import { imageBasePath } from '../../../constants';
import OverviewTitle from './OverviewTitle';
import { Grid } from '@material-ui/core';
import { CustomDoughnutChart } from '../../../shared_elements';
import { useGetFF } from '@fstack-tech/ff_react_module';
import { useGetHomeSkillPaths } from '../../../features/training/Training.queries';
import AdminHomeCard from 'features/training/components/SkillPathsDashboardAdmin/AdminHomeCard';
export default function TrainingOverview(props) {
  const { training = {} } = props;
  const { isEnabled: label_changes } = useGetFF({ flag_id: 'label_changes' });
  const { isEnabled: ff_learning_paths } = useGetFF({ flag_id: 'learning_paths' });
  const { data: homeSkillPaths = {} } = useGetHomeSkillPaths({ enabled: true });
  console.log(homeSkillPaths);
  return (
    <div className={styles.moduleOverview}>
      <OverviewTitle
        icon={`${imageBasePath}training_default.svg`}
        title={`${label_changes ? 'Upskilling' : 'training'}`}
        moduleLink={'/training'}
        secondModuleLink={'/training?active=modules'}
      />
      {ff_learning_paths ? (
        <AdminHomeCard homeData={homeSkillPaths?.data} />
      )
        : (
          <Grid
            container
            className={`${styles.onboardingOverviewWrapper} ${styles.defaultOverviewWrapper} ${styles.trainingOverviewWrapper}`}
            alignItems="center"
          >
            <Grid item xs={12} md={4}>
              <div className={styles.infoWrapper}>
                <h3 className="heading2">{training?.progress?.total_published_modules}</h3>
                <p className="paragraph">Total {ff_learning_paths ? 'skill sets' : 'modules'} available</p>
              </div>
              {/* <div className={`${styles.infoWrapper}`}>
            <h3 className="heading2">{Math.round(training?.average_overall_readiness_index)}%</h3>
            <p className="paragraph">Sales Readiness Index</p>
          </div> */}
            </Grid>
            <Grid item xs={12} md={8}>
              <div className={styles.chartWrapper}>
                <CustomDoughnutChart
                  direction="row-reverse"
                  page="training"
                  type="dashboard"
                  chartData={training}
                />
              </div>
            </Grid>
          </Grid>
        )}

    </div>
  );
}
